import { render, staticRenderFns } from "./OpenUser.vue?vue&type=template&id=6877dc2d&scoped=true&"
import script from "./OpenUser.vue?vue&type=script&lang=js&"
export * from "./OpenUser.vue?vue&type=script&lang=js&"
import style0 from "./OpenUser.vue?vue&type=style&index=0&id=6877dc2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6877dc2d",
  null
  
)

export default component.exports